import React from "react";
import "./About.css";
import Popup from "../components/popup.js";
import { Client, Databases, ID } from "appwrite";
import { useEffect, useRef, useState } from "react";
import Randomwalklogo from "../assets/Visual-ai/Randomwalklogo.webp";
import visualai from "../assets/Visual-ai/visualai.webp";
import visualai2 from "../assets/Visual-ai/visualai2.webp";
import visualai3 from "../assets/Visual-ai/visualai3.webp";
import visualai4 from "../assets/Visual-ai/visualai4.webp";
import visualai5 from "../assets/Visual-ai/visualai5.webp";
import visualai6 from "../assets/Visual-ai/visualai6.webp";
import visualai7 from "../assets/Visual-ai/visualai7.webp";
import visualai8 from "../assets/Visual-ai/visualai8.webp";
import visualai9 from "../assets/Visual-ai/visualai9.webp";
import visualai10 from "../assets/Visual-ai/visualai10.webp";
import visualai11 from "../assets/Visual-ai/visualai11.webp";
import visualai12 from "../assets/Visual-ai/visualai12.webp";
import visualai13 from "../assets/Visual-ai/visualai13.webp";
import visualai14 from "../assets/Visual-ai/visualai14.webp";
import visualai15 from "../assets/Visual-ai/visualai15.webp";
import visualai16 from "../assets/Visual-ai/visualai16.webp";
import visualai17 from "../assets/Visual-ai/visualai17.webp";
import visualai18 from "../assets/Visual-ai/visualai18.webp";
import visualai19 from "../assets/Visual-ai/visualai19.webp";
import visualai20 from "../assets/Visual-ai/visualai20.webp";
import visualai21 from "../assets/Visual-ai/visualai21.webp";

import { Helmet } from "react-helmet-async";
import PhoneInput from "react-phone-input-2";
import {
  parsePhoneNumberFromString,
  isValidPhoneNumber,
} from "libphonenumber-js";

const Visualai = () => {
  useEffect(() => {

    document.title = "Visual ai | Random Walk";

    // Set meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute(
        "content",
        "Random Walk is on a mission to democratize AI, offering AI solutions and AI services to businesses and individuals, helping them understand AI and utilize AI tools for growth and innovation."
      );
    } else {
      const meta = document.createElement("meta");
      meta.name = "description";
      meta.content =
        "Random Walk is on a mission to democratize AI, offering AI solutions and AI services to businesses and individuals, helping them understand AI and utilize AI tools for growth and innovation.";
      document.head.appendChild(meta);
    }

    // Add or update Open Graph title
    let ogTitle = document.querySelector('meta[property="og:title"]');
    if (!ogTitle) {
      ogTitle = document.createElement("meta");
      ogTitle.setAttribute("property", "og:title");
      document.head.appendChild(ogTitle);
    }
    ogTitle.setAttribute("content", "Visual ai | Random Walk");

    // Add or update Open Graph description
    let ogDescription = document.querySelector(
      'meta[property="og:description"]'
    );
    if (!ogDescription) {
      ogDescription = document.createElement("meta");
      ogDescription.setAttribute("property", "og:description");
      document.head.appendChild(ogDescription);
    }
    ogDescription.setAttribute(
      "content",
      "Random Walk is on a mission to democratize AI, offering AI solutions and AI services to businesses and individuals, helping them understand AI and utilize AI tools for growth and innovation."
    );

    // Add viewport meta tag
    let viewport = document.querySelector('meta[name="viewport"]');
    if (!viewport) {
      viewport = document.createElement("meta");
      viewport.name = "viewport";
      document.head.appendChild(viewport);
    }
    viewport.setAttribute("content", "width=device-width, initial-scale=1");

    // Add theme-color meta tag
    let themeColor = document.querySelector('meta[name="theme-color"]');
    if (!themeColor) {
      themeColor = document.createElement("meta");
      themeColor.name = "theme-color";
      document.head.appendChild(themeColor);
    }
    themeColor.setAttribute("content", "#000000");

    // Add Open Graph image
    let ogImage = document.querySelector('meta[property="og:image"]');
    if (!ogImage) {
      ogImage = document.createElement("meta");
      ogImage.setAttribute("property", "og:image");
      document.head.appendChild(ogImage);
    }
    ogImage.setAttribute("content", `${process.env.PUBLIC_URL}/rw_logo.png`);

    // Add Open Graph type
    let ogType = document.querySelector('meta[property="og:type"]');
    if (!ogType) {
      ogType = document.createElement("meta");
      ogType.setAttribute("property", "og:type");
      document.head.appendChild(ogType);
    }
    ogType.setAttribute("content", "website");

    // Add canonical link
    let canonicalLink = document.querySelector('link[rel="canonical"]');
    if (!canonicalLink) {
      canonicalLink = document.createElement("link");
      canonicalLink.rel = "canonical";
      document.head.appendChild(canonicalLink);
    }
    canonicalLink.href = "https://randomwalk.ai/visual-ai";
  }, []);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSuccessOpen, setIsSuccessOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [firstname, setfirstname] = useState("");
  const [lastname, setlastname] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [businessemail, setEmailId] = useState("");
  const [projectdetails, setprojectdetails] = useState("");
  const [isChecked, setIsChecked] = useState(true);
  const [utmParams, setUtmParams] = useState({
    utm_source: "",
    utm_medium: "",
    utm_campaign: "",
    utm_id: "",
    utm_term: "",
    utm_content: "",
  });
  const [errors, setErrors] = useState({});

  const resetForm = () => {
    setfirstname("");
    setlastname("");
    setPhoneNumber("");

    setCompanyName("");
    setEmailId("");
    setprojectdetails("");
    setIsChecked(true);
    setErrors({});
  };

  const handleButtonClickcontact = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    resetForm();
  };

  const handleCheckboxChange = (e) => {
    setIsChecked(e.target.checked);
  };
  const closeSuccessModal = () => {
    setIsSuccessOpen(false);
    resetForm();
  };



  const handleSubmitcontact = async (event) => {
    event.preventDefault();
    setIsLoading(true);
  
    try {
      // Validate phone number
      if (!phoneNumber) {
        setErrors({ phoneNumber: "Phone number is required" });
        setIsLoading(false);
        return;
      }
  
      const fullNumber = phoneNumber.startsWith("+")
        ? phoneNumber
        : `+${phoneNumber}`;
      if (!isValidPhoneNumber(fullNumber)) {
        setErrors((prev) => ({
          ...prev,
          phoneNumber: "Please enter a valid phone number",
        }));
        setIsLoading(false);
        return;
      }
  
      const formData = {
        firstname,
        lastname,
        businessemail,
        companyName,
        phoneNumber,
        projectdetails,
        utmSource: utmParams.utm_source,
        utmMedium: utmParams.utm_medium,
        utmCampaign: utmParams.utm_campaign,
        utmId: utmParams.utm_id,
        utmTerm: utmParams.utm_term,
        utmContent: "visual-ai",
      };
  
      // First try to submit to Appwrite
      let appwriteSuccess = false;
      try {
        await databases.createDocument(
          process.env.REACT_APP_DATABASE_ID,
          process.env.REACT_APP_COLLECTION_ID2,
          ID.unique(),
          formData
        );
        appwriteSuccess = true;
      } catch (appwriteError) {
        console.error("Appwrite submission failed:", appwriteError);
        // Continue with backend submission even if Appwrite fails
      }
  
      // Then try to submit to Express backend
      let backendSuccess = false;
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}/api/submit-form`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(formData),
          }
        );
  
        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.message || "Failed to submit form");
        }
        backendSuccess = true;
      } catch (backendError) {
        console.error("Backend submission failed:", backendError);
        // If backend fails but Appwrite succeeded, we can still consider it a partial success
      }
  
      // If either submission was successful, show success message
      if (appwriteSuccess || backendSuccess) {
        setIsModalOpen(false);
        setIsSuccessOpen(true);
        resetForm();
      } else {
        // Both submissions failed
        throw new Error("Failed to submit form to both services");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      setErrors((prev) => ({
        ...prev,
        submit:
          "Failed to submit form. Please try again or contact support if the issue persists.",
      }));
    } finally {
      setIsLoading(false);
    }
  };

  console.log(`Backend URL: ${process.env.REACT_APP_BACKEND_URL}`);
  const client = new Client()
    .setEndpoint(process.env.REACT_APP_ENDPOINT)
    .setProject(process.env.REACT_APP_PROJECT_ID);

  const databases = new Databases(client);

  const handlePhoneNumberChange = (number, country) => {
    setPhoneNumber(number);

    try {
      // Ensure number starts with +
      const fullNumber = number.startsWith("+") ? number : `+${number}`;

      // Check if the number is valid for the selected country
      if (isValidPhoneNumber(fullNumber)) {
        const phoneNumberObj = parsePhoneNumberFromString(fullNumber);
        const nationalNumber = phoneNumberObj.nationalNumber;

        // Get expected length based on country
        const expectedLength = phoneNumberObj.nationalNumber?.length;
        const actualLength = nationalNumber?.length;

        if (actualLength < expectedLength) {
          setErrors((prev) => ({
            ...prev,
            phoneNumber: `Phone number is too short - needs ${expectedLength} digits`,
          }));
        } else if (actualLength > expectedLength) {
          setErrors((prev) => ({
            ...prev,
            phoneNumber: `Phone number is too long - should be ${expectedLength} digits`,
          }));
        } else {
          // Clear the error when valid
          setErrors((prev) => ({
            ...prev,
            phoneNumber: "",
          }));
        }
      } else {
        setErrors((prev) => ({
          ...prev,
          phoneNumber: "Please enter a valid phone number",
        }));
      }
    } catch (error) {
      console.error("Phone validation error:", error);
      setErrors((prev) => ({
        ...prev,
        phoneNumber: "Please enter a valid phone number",
      }));
    }
  };
  return (
    <div className="">
      
      <section className="relative h-screen w-full flex flex-col justify-center items-center bg-no-repeat bg-cover bg-white">
        <img
          src={Randomwalklogo}
          alt="Background Image"
          loading="lazy"
          className="absolute top-0 left-48 md:left-1/2 transform -translate-x-1/2 mt-2 "
        />

        <div className="text-[#172d45] text-center relative z-10 px-4   mt-64  md:mt-20 lg:px-16  lg:mt-32 2xl:mt-1">
          <div
            className="flex flex-col lg:space-y-3 text-5xl lg:text-6xl 2xl:text-7xl font-bold pb-5"
            style={{ fontFamily: "Trebuchet MS, sans-serif" }}
          >
            <div className="mb-2">
              <span className="text-[#c62b6d]">
                Revolutionizing Workplace Safety
              </span>{" "}
              and
            </div>
            <div>Operational Efficiency with Visual AI</div>
          </div>

          <div
            className="text-2xl lg:text-3xl 2xl:text-4xl text-left px-4 lg:px-16 mt-6 2xl:mt-12 text-[#334998]"
            style={{ fontFamily: "TT Fors, sans-serif" }}
          >
            Ensure a secure, compliant, and highly efficient environment with
            <span className="font-bold">
              {" "}
              Random Walk’s advanced Visual AI solutions
            </span>
            . Our AI-powered systems go beyond safety, delivering real-time
            analytics, automated incident detection, and operational insights
            tailored to multiple industries.
          </div>
          <a href="/contact-us" target="_blank" rel="noopener noreferrer">
            <button
              className="px-4 py-4 text-black font-medium text-3xl 2xl:text-4xl mt-6
  bg-gradient-to-b from-[#c56ea3] to-[#fb776e]
  border-4 border-[#ffa6c7]
  rounded-xl
  hover:shadow-[2px_2px_0px_#b14773]
  active:shadow-[1px_1px_0px_#b14773]
  transition-all duration-150"
              style={{ fontFamily: "Trebuchet MS, sans-serif" }}
            >
              Talk to Our Experts
            </button>
          </a>
        </div>
      </section>

      <section className="flex flex-col md:flex-row  items-center justify-between px-4 lg:px-16 py-6 mt-20 md:mt-0">
        <div className="w-full md:w-1/2 text-left self-start  lg:mt-[-20px] ">
          <h2
            className="text-left text-6xl 2xl:text-7xl font-bold text-[#c62b6d]"
            style={{ fontFamily: "Trebuchet MS, sans-serif" }}
          >
            Proven Expertise in
            <br className="block md:hidden" />
            <span className="text-[#c62b6d] mt-4 inline-block">Visual AI</span>
          </h2>
          <p
            className="text-xl 2xl:text-2xl text-black mt-4 lg:mt-16 2xl:mt-10 font-light leading-normal"
            style={{ fontFamily: "TT Fors, sans-serif" }}
          >
            <span className="font-extrabold">
              Random Walk has successfully delivered 5+ large-scale Visual AI
              projects
            </span>
            , each monitoring{" "}
            <span className="font-bold">
              100+ key performance indicators (KPIs).
            </span>{" "}
            These projects cover vast spaces, processing multiple CCTV feeds
            simultaneously. Our proprietary AI models converge multiple video
            streams, cross-verifying events before flagging or recording
            incidents, significantly reducing false positives.
          </p>
          <p
            className="text-xl 2xl:text-2xl text-black mt-10 font-light leading-normal"
            style={{ fontFamily: "TT Fors, sans-serif" }}
          >
            With <span className="font-extrabold">large-scale datasets</span>{" "}
            used for model training, we continuously enhance precision and
            reliability, ensuring cutting-edge AI performance for our clients.
          </p>
        </div>

        <div className="w-full md:w-1/2 flex flex-col items-center mt-12">
          <img
            src={visualai}
            alt="Description"
            className="max-w-full h-auto 2xl:w-8/12 shadow-md"
          />
          <a
            href="/contact-us"
            target="_blank"
            rel="noopener noreferrer"
            className="mt-6"
          >
            <button
              className="px-6 py-4 text-black font-medium text-2xl
      bg-gradient-to-b from-[#c56ea3] to-[#fb776e]
      border-4 border-[#ffa6c7]
      rounded-xl
      hover:shadow-[2px_2px_0px_#b14773]
      active:shadow-[1px_1px_0px_#b14773]
      transition-all duration-150"
              style={{ fontFamily: "Trebuchet MS, sans-serif" }}
            >
              Talk to Our Experts
            </button>
          </a>
        </div>
      </section>

      <div className="w-full flex flex-col items-center text-center lg:mt-16 ">
        <h3
          className="text-6xl font-bold text-[#c62b6d] px-2 md:px-6"
          style={{ fontFamily: "Trebuchet MS, sans-serif" }}
        >
          Expanding Beyond Safety: Tailored Visual{" "}
          <span className="mt-4 inline-block">AI Applications </span>
        </h3>
        <p
          className="text-3xl text-black  font-extrabold  px-4 md:px-20 mt-10"
          style={{ fontFamily: "TT Fors, sans-serif" }}
        >
          While safety remains a core focus, Random Walk’s Visual AI solutions
          extend to various industry needs, including:
        </p>
      </div>
      <section className="flex flex-col md:flex-row items-center justify-between md:px-4 lg:px-16 py-6 mt-4">
        {/* Left Side - Text Content (60%) */}
        <div
          className="w-full md:w-3/5 text-center px-4"
          style={{ fontFamily: "TT Fors, sans-serif" }}
        >
          <h2 className="text-2xl 2xl:text-4xl text-left font-extrabold text-[#334998] mb-4">
            Retail & Commercial Spaces
          </h2>
          <p className="text-xl 2xl:text-2xl text-black font-extralight text-left mb-2">
            <span className="font-extrabold">Footfall Analytics – </span> Track
            visitor movement patterns to optimize store layouts and enhance
            customer experience.
          </p>
          <p className="text-xl 2xl:text-2xl text-black font-extralight text-left mb-2">
            <span className="font-extrabold">
              Queue Management & Waiting Time Analysis –{" "}
            </span>
            Monitor customer wait times at service desks and checkout counters
            to improve efficiency.
          </p>
          <p className="text-xl 2xl:text-2xl text-black font-extralight text-left mb-2">
            <span className="font-extrabold"> Anomaly Detection – </span>
            Identify suspicious behavior, theft, or unusual crowd formations for
            security teams.
          </p>
          <a
            href="/contact-us"
            target="_blank"
            rel="noopener noreferrer"
            className="mt-10 mr-20"
          >
            <button
              className="px-4 py-2 text-black font-medium text-2xl
      bg-gradient-to-b from-[#c56ea3] to-[#fb776e]
      border-4 border-[#ffa6c7]
      rounded-xl
      hover:shadow-[2px_2px_0px_#b14773]
      active:shadow-[1px_1px_0px_#b14773]
      transition-all duration-150"
              style={{ fontFamily: "Trebuchet MS, sans-serif" }}
            >
              Talk to Our Experts
            </button>
          </a>
        </div>

        {/* Right Side - Image (40%) */}
        <div className="w-full md:w-2/5 flex justify-end mt-5 md:mt-0">
          <img
            src={visualai2}
            alt="Description"
            className="max-w-full h-auto rounded-lg shadow-md"
          />
        </div>
      </section>
      <section className="flex flex-col md:flex-row items-center justify-between md:px-4 lg:px-16  py-6 md:mt-4">
        {/* Left Side - Image (40%) */}
        <div className="w-full md:w-2/5 flex justify-start items-center mt-0 md:mt-0">
          <img
            src={visualai4}
            alt="Description"
            className="max-w-full h-auto rounded-lg shadow-md"
          />
        </div>

        {/* Right Side - Text Content (60%) */}
        <div
          className="w-full md:w-3/5 text-center px-4 mt-10 md:mt-0 md:px-10 self-start"
          style={{ fontFamily: "TT Fors, sans-serif" }}
        >
          <h2 className="text-2xl 2xl:text-4xl font-extrabold text-[#334998] mb-4 text-left ">
            Manufacturing & Industrial Sites
          </h2>

          <p className="text-xl 2xl:text-2xl text-black text-left font-extralight mb-2">
            <span className="font-extrabold">Safe Distance Monitoring – </span>
            Ensure a safe working environment by maintaining human-machine
            distance regulations.
          </p>

          <p className="text-xl 2xl:text-2xl text-black text-left font-extralight mb-2">
            <span className="font-extrabold">
              Fall Detection & Hazard Alerts -
            </span>
            Detect slips, falls, and worker distress in real time to initiate
            immediate response.
          </p>

          <p className="text-xl 2xl:text-2xl text-black  text-left font-extralight mb-2">
            <span className="font-extrabold">Fire & Smoke Detection – </span>
            AI-powered detection systems can alert operators before fires
            escalate.
          </p>

          <p className="text-xl 2xl:text-2xl text-black  text-left font-extralight mb-2">
            <span className="font-extrabold">
              SOP Compliance & Board Detection –{" "}
            </span>
            Ensure adherence to safety standard operating procedures through
            AI-driven monitoring.
          </p>
          {/* Button aligned under text content */}
          <a
            href="/contact-us"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block mt-2"
          >
            <button
              className="px-6 py-3 text-black font-medium text-2xl
      bg-gradient-to-b from-[#c56ea3] to-[#fb776e]
      border-4 border-[#ffa6c7]
      rounded-xl
      hover:shadow-[2px_2px_0px_#b14773]
      active:shadow-[1px_1px_0px_#b14773]
      transition-all duration-150"
              style={{ fontFamily: "Trebuchet MS, sans-serif" }}
            >
              Talk to Our Experts
            </button>
          </a>
        </div>
      </section>

      <section className="flex flex-col md:flex-row items-center justify-between md:px-4 lg:px-16  py-6 mt-4">
        {/* Left Side - Text Content (60%) */}
        <div
          className="w-full md:w-3/5 text-center px-4"
          style={{ fontFamily: "TT Fors, sans-serif" }}
        >
          <h2 className="text-2xl 2xl:text-4xl text-left font-extrabold text-[#334998] mb-4">
            Construction & Infrastructure
          </h2>
          <p className="text-xl 2xl:text-2xl text-black font-extralight text-left mb-2">
            <span className="font-extrabold">
              Structural Stability & Defect Identification –{" "}
            </span>{" "}
            Analyze cracks, alignment issues, and material degradation in
            buildings.
          </p>
          <p className="text-xl 2xl:text-2xl text-black font-extralight text-left mb-2">
            <span className="font-extrabold">
              Workplace Safety Violations –{" "}
            </span>
            Detect missing PPE, unsafe scaffolding, and unauthorized personnel
            access.
          </p>
          <p className="text-xl 2xl:text-2xl text-black font-extralight text-left mb-2">
            <span className="font-extrabold">
              Placement of Safety Provisions –{" "}
            </span>
            Verify the correct positioning of safety blinds, barriers, and
            emergency exits.
          </p>
          <a
            href="/contact-us"
            target="_blank"
            rel="noopener noreferrer"
            className="mt-10 mr-20 "
          >
            <button
              className="px-4 py-2 text-black font-medium text-2xl
      bg-gradient-to-b from-[#c56ea3] to-[#fb776e]
      border-4 border-[#ffa6c7]
      rounded-xl
      hover:shadow-[2px_2px_0px_#b14773]
      active:shadow-[1px_1px_0px_#b14773]
      transition-all duration-150"
              style={{ fontFamily: "Trebuchet MS, sans-serif" }}
            >
              Talk to Our Experts
            </button>
          </a>
        </div>

        {/* Right Side - Image (40%) */}
        <div className="w-full md:w-2/5 flex justify-end mt-5 md:mt-0">
          <img
            src={visualai3}
            alt="Description"
            className="max-w-full h-auto rounded-lg shadow-md"
          />
        </div>
      </section>

      <section className="flex flex-col md:flex-row items-center justify-between md:px-4 lg:px-16 py-6 mt-4">
        {/* Left Side - Image (40%) */}
        <div className="w-full md:w-2/5 flex justify-start items-center mt-6 md:mt-0">
          <img
            src={visualai5}
            alt="Description"
            className="max-w-full h-auto rounded-lg shadow-md"
          />
        </div>

        {/* Right Side - Text Content (60%) */}
        <div
          className="w-full md:w-3/5 text-center md:px-10 px-4 self-start"
          style={{ fontFamily: "TT Fors, sans-serif" }}
        >
          <h2 className="text-2xl 2xl:text-4xl font-extrabold text-[#334998] mb-4 text-left ">
            Healthcare & Public Services
          </h2>

          <p className="text-xl 2xl:text-2xl text-black text-left font-extralight mb-2">
            <span className="font-extrabold">PPE & Hygiene Compliance – </span>
            Ensure adherence to protective gear and sanitation protocols in
            hospitals and laboratories.
          </p>

          <p className="text-xl 2xl:text-2xl text-black text-left font-extralight mb-2">
            <span className="font-extrabold">
              Emergency Response Readiness –{" "}
            </span>
            Identify medical emergencies in real time and trigger immediate
            response measures.
          </p>

          <button
            className="px-6 py-3 text-black font-medium text-2xl
      bg-gradient-to-b from-[#c56ea3] to-[#fb776e]
      border-4 border-[#ffa6c7]
      rounded-xl
      hover:shadow-[2px_2px_0px_#b14773]
      active:shadow-[1px_1px_0px_#b14773]
      transition-all duration-150"
            onClick={handleButtonClickcontact}
            style={{ fontFamily: "Trebuchet MS, sans-serif" }}
          >
            Talk to Our Experts
          </button>

          {/* Button aligned under text content */}
          {/* <a href="/contact-us" target="_blank" rel="noopener noreferrer" className="inline-block mt-2">
    <button className="px-6 py-3 text-black font-medium text-2xl
      bg-gradient-to-b from-[#c56ea3] to-[#fb776e]
      border-4 border-[#ffa6c7]
      rounded-xl
      hover:shadow-[2px_2px_0px_#b14773]
      active:shadow-[1px_1px_0px_#b14773]
      transition-all duration-150"
      style={{ fontFamily: "Trebuchet MS, sans-serif" }}>
      Talk to Our Experts
    </button>
  </a> */}
        </div>
      </section>
      <div className="flex flex-col md:flex-row w-full p-4 gap-6">
        
  {/* Left Section (Appears first in mobile view) */}
  <div className="w-full md:w-2/5 bg-white p-6 flex flex-col items-center text-center" style={{ fontFamily: "Trebuchet MS, sans-serif" }}>
    <img src={Randomwalklogo} alt="Left Image" className="-mt-10 mb-4 object-cover" />
    <h2 className="text-5xl font-semibold mb-16">What They Say</h2>
    <a href="/contact-us" target="_blank" rel="noopener noreferrer" className="inline-block mt-2">
      <button className="px-6 py-3 text-black font-medium text-2xl 
                         bg-gradient-to-b from-[#c56ea3] to-[#fb776e] 
                         border-4 border-[#ffa6c7] 
                         rounded-xl 
                         hover:shadow-[2px_2px_0px_#b14773] 
                         active:shadow-[1px_1px_0px_#b14773] 
                         transition-all duration-150" 
              style={{ fontFamily: "Trebuchet MS, sans-serif" }}>
        Talk to Our Experts
      </button>
    </a>
  </div>
  {/* Right Section (Moves below on mobile) */}
  <div className="w-full md:w-3/5 bg-white p-6 flex flex-col gap-6 md:ml-auto">
  {[
    {
      src: visualai6,
      heading: "Martha Blevins",
      text: "Our store's safety and efficiency have improved significantly with AI-powered footfall analytics and queue management. Customers are happier, and security concerns have reduced.",
    },
    {
      src: visualai7,
      heading: "Alfonso Perez",
      text: "The fall detection and fire alert systems have made our workplace much safer. We've prevented multiple incidents and feel more confident about worker safety.",
    },
    {
      src: visualai8,
      heading: "Rin Katayama",
      text: "AI monitoring has helped us catch safety violations early, ensuring our workers stay protected. It's made a real difference in reducing risks on-site.",
    },
  ].map((item, index) => (
    <div
      key={index}
      className="flex flex-col sm:flex-row items-start sm:items-center gap-4 sm:gap-6 bg-white p-4 sm:p-6 px-4 lg:px-16 -mt-10"
    >
      <img
        src={item.src}
        alt={`Image ${index + 1}`}
        className="w-24 h-24 sm:w-32 sm:h-32 rounded-lg object-cover self-start"
      />
      <div className="mt-3 sm:mt-0">
        <p
          className="text-black text-lg 2xl:text-xl sm:text-xl font-extrabold mb-1 sm:mb-2"
          style={{ fontFamily: "TT Fors, sans-serif" }}
        >
          {item.heading}
        </p>
        <p
          className="text-black  2xl:text-xl font-thin text-base sm:text-lg"
          style={{ fontFamily: "DM Sans, sans-serif" }}
        >
          {item.text}
        </p>
      </div>
    </div>
  ))}
</div>
</div>

<div className="px-3 text-center mt-10 md:mt-20 lg:mt-0">
  <h2 className="text-3xl md:text-5xl font-bold text-[#c62b6d] mb-4 md:mb-6" style={{ fontFamily: "Trebuchet MS, sans-serif" }}>
    Key Benefits of Visual AI Solutions
  </h2>

  {/* Mobile-friendly container with centered stacked boxes */}
  <div className="flex flex-col items-center gap-8 md:gap-32 mt-8 md:mt-16">
    
    {/* Desktop view: first row with 2 boxes */}
    <div className="flex flex-col md:flex-row w-full justify-center gap-8 md:gap-32">
      {/* Benefit 1 */}
      <div className="relative border-2 border-yellow-500 rounded-3xl p-5 w-full md:w-4/12 text-left self-center md:self-start" style={{ fontFamily: "Open Sauce, sans-serif" }}>
        <h3 className="font-bold text-2xl md:text-3xl text-[#172d45]">
          Incident Prevention & Real-Time Alerts
        </h3>
        <p className="text-gray-700 text-xl md:text-2xl font-light mt-2">
          AI-powered systems instantly flag safety risks and operational bottlenecks.
        </p>
        <div className="justify-end items-left">
          <img
            src={visualai10}
            alt="Alert Icon"
            className="w-12 h-12"
          />
        </div>
        <img
          src={visualai9}
          alt="Alert Icon"
          className="hidden md:block absolute bottom-[-44px] right-[-96px]"
        />
           <img
          src={visualai9}
          alt="Alert Icon"
          className="hidden md:hidden absolute bottom-[-44px] right-[-96px]"
        />
      </div>

      {/* Benefit 2 - Styled for desktop staggered layout */}
      <div className="relative border-2 border-yellow-500 rounded-2xl p-5 w-full md:w-4/12 text-left self-center md:self-start md:mt-44" style={{ fontFamily: "Open Sauce, sans-serif" }}>
        <h3 className="font-bold text-2xl md:text-3xl text-[#172d45]">
          Data-Driven Decision Making
        </h3>
        <p className="text-gray-700 text-xl md:text-2xl font-light mt-2">
          Gain actionable insights for predictive risk management and efficiency improvements.
        </p>
        <div className="justify-end items-left">
          <img
            src={visualai10}
            alt="Alert Icon"
            className="w-12 h-12"
          />
        </div>
        <img
          src={visualai11}
          alt="Chart Icon"
          className="hidden md:block absolute bottom-[-44px] right-[-96px]"
        />
      </div>
    </div>

    {/* Desktop view: second row with 2 boxes */}
    <div className="flex flex-col md:flex-row w-full justify-center gap-8 md:gap-32 md:-mt-44">
      {/* Benefit 3 */}
      <div className="relative border-2 border-yellow-500 rounded-3xl p-5 w-full md:w-4/12 text-left self-center md:self-start" style={{ fontFamily: "Open Sauce, sans-serif" }}>
        <h3 className="font-bold text-2xl md:text-3xl text-[#172d45]">
          Customizable & Scalable
        </h3>
        <p className="text-gray-700 text-xl md:text-2xl font-light mt-2">
          Solutions tailored for diverse industries and evolving business needs.
        </p>
        <div className="justify-end items-left ">
          <img
            src={visualai10}
            alt="Alert Icon"
            className="w-12 h-12"
          />
        </div>
        <img
          src={visualai12}
          alt="Alert Icon"
          className="hidden md:block absolute bottom-[-44px] right-[-80px]"
        />
      </div>

      {/* Benefit 4 - Styled for desktop staggered layout */}
      <div className="relative border-2 border-yellow-500 rounded-2xl p-5 w-full md:w-4/12 text-left self-center md:self-start md:mt-44" style={{ fontFamily: "Open Sauce, sans-serif" }}>
        <h3 className="font-bold text-2xl md:text-3xl text-[#172d45]">
          Regulatory Compliance & Risk Mitigation
        </h3>
        <p className="text-gray-700 text-xl md:text-2xl font-light mt-2">
          Ensure adherence to industry regulations while avoiding penalties.
        </p>
        <div className=" justify-end items-left">
          <img
            src={visualai10}
            alt="Alert Icon"
            className="w-12 h-12"
          />
        </div>
        <img
          src={visualai13}
          alt="Chart Icon"
          className="hidden md:block absolute bottom-[-44px] right-[-96px]"
        />
      </div>
    </div>

    {/* Desktop view: third row with last box */}
    <div className="flex flex-col md:flex-row w-full justify-center gap-8 md:gap-32 md:-mt-44">
      {/* Benefit 5 */}
      <div className="relative border-2 border-yellow-500 rounded-3xl p-5 w-full md:w-4/12 text-left self-center md:self-start" style={{ fontFamily: "Open Sauce, sans-serif" }}>
        <h3 className="font-bold text-2xl md:text-3xl text-[#172d45]">
          Reduced Operational Downtime
        </h3>
        <p className="text-gray-700 text-xl md:text-2xl font-light mt-2">
          AI-driven monitoring improves workflows and prevents costly disruptions
        </p>
        <div className=" justify-end items-left">
          <img
            src={visualai10}
            alt="Alert Icon"
            className="w-12 h-12"
          />
        </div>
        <img
          src={visualai14}
          alt="Alert Icon"
          className="hidden md:block absolute bottom-[-44px] right-[-80px]"
        />
      </div>

      {/* Empty div for desktop layout */}
      <div className="hidden md:block w-4/12 md:mt-44"></div>
    </div>
  </div>
</div>
      <div className="flex justify-center mt-12">
        <a
          href="/contact-us"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block"
        >
          <button
            className="px-6 py-3 text-black font-medium text-2xl
    bg-gradient-to-b from-[#c56ea3] to-[#fb776e]
    border-4 border-[#ffa6c7]
    rounded-xl
    hover:shadow-[2px_2px_0px_#b14773]
    active:shadow-[1px_1px_0px_#b14773]
    transition-all duration-150"
            style={{ fontFamily: "Trebuchet MS, sans-serif" }}
          >
            Talk to Our Experts
          </button>
        </a>
      </div>
      <div className="flex flex-col items-center text-center px-4 py-10">
    <h2 className="text-6xl font-bold text-[#c62b6d]"style={{ fontFamily: "Trebuchet MS, sans-serif" }}>
      Why Choose Random Walk?
    </h2>
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 lg:gap-10 2xl:gap-20 mt-16 max-w-4xl">

      <div className="flex flex-col items-center">
        <img
          src={visualai15}
          alt="Proven Track Record"
          className=""
        />
        <h3 className="text-2xl 2xl:text-3xl font-extrabold text-[#c62b6d] mt-4 mb-4"style={{ fontFamily: "TT Fors, sans-serif" }}>
          Proven Track Record
        </h3>
        <p className="text-[#334998] font-light text-xl 2xl:text-2xl"style={{ fontFamily: "TT Fors, sans-serif" }}>
          Successfully executed large-scale Visual AI deployments with 100+ KPI monitoring.
        </p>
      </div>


      <div className="flex flex-col items-center">
        <img
          src={visualai16}
          alt="Advanced AI Models"
          className="w-24 h-24"
        />
        <h3 className="text-2xl 2xl:text-3xl font-extrabold text-[#c62b6d] mt-4 mb-4"style={{ fontFamily: "TT Fors, sans-serif" }}>
          Advanced AI Models
        </h3>
        <p className="text-[#334998] text-xl 2xl:text-2xl" style={{ fontFamily: "TT Fors, sans-serif" }}>
          Our AI continually learns and improves to enhance accuracy and efficiency.
        </p>
      </div>

 
      <div className="flex flex-col items-center">
        <img
          src={visualai17}
          alt="Seamless Integration"
          className="w-34 h-32"
        />
        <h3 className="text-2xl  2xl:text-3xl
        font-extrabold text-[#c62b6d] mt-4 mb-4"style={{ fontFamily: "TT Fors, sans-serif" }}>
          Seamless Integration
        </h3>
        <p className="text-[#334998] text-xl 2xl:text-2xl" style={{ fontFamily: "TT Fors, sans-serif" }}>
          Works with existing security, monitoring, and operational systems.
        </p>
      </div>

    
      <div className="flex flex-col items-center">
        <img
          src={visualai18}
          alt="Custom-Tailored Solutions"
          className="w-32 h-32"
        />
        <h3 className="text-xl 2xl:text-xl font-extrabold text-[#c62b6d] mt-4 mb-4"style={{ fontFamily: "TT Fors, sans-serif" }}>
          Custom-Tailored Solutions
        </h3>
        <p className="text-[#334998] text-xl 2xl:text-2xl"style={{ fontFamily: "TT Fors, sans-serif" }}>
          Visual AI applications designed to meet specific client needs.
        </p>
      </div>
    </div>
  </div>
      <div className="flex justify-center ">
<a href="/contact-us" target="_blank" rel="noopener noreferrer" className="inline-block">
  <button className="px-6 py-3 text-black font-medium text-3xl
    bg-gradient-to-b from-[#c56ea3] to-[#fb776e]
    border-4 border-[#ffa6c7]
    rounded-xl
    hover:shadow-[2px_2px_0px_#b14773]
    active:shadow-[1px_1px_0px_#b14773]
    transition-all duration-150"
    style={{ fontFamily: "Trebuchet MS, sans-serif" }}>
    Talk to Our Experts
  </button>
</a>
</div>

      <div className="flex flex-col items-left text-left md:px-10 lg::px-16 mt-10">
   
    <img src={Randomwalklogo} alt="Random Walk Logo" className="w-96 mb-4" />

 
    <h1 className="text-6xl font-medium text-[#c62b6d] px-6"style={{ fontFamily: "Trebuchet MS, sans-serif" }}>
<span className="mb-4 block">Take the Next Step in AI-Driven</span>
Transformation
</h1>


   
    <p className="text-2xl font-extrabold text-blue-900 mt-4 px-6"style={{ fontFamily: "TT Fors, sans-serif" }}>
     Enhance safety, streamline operations, and drive efficiency with  <br/>Random Walk’s Visual AI solutions.
    </p>

    <div className="flex flex-wrap justify-center md:gap-2 lg:gap-24 mt-6">
      <div className="flex items-center space-x-2">
        <img src={visualai19} alt="Email Icon" className="w-10 h-10" />
        <span className="text-2xl font-bold text-[#c62b6d]">CONTACT US</span>
      </div>

      <div className="flex items-center space-x-2">
        <img src={visualai20} alt="Phone Icon" className="w-10 h-10" />
        <span className="text-2xl font-bold text-[#c62b6d]">SCHEDULE A CONSULTATION</span>
      </div>

      <div className="flex items-center space-x-2">
        <img src={visualai21} alt="Website Icon" className="w-10 h-10" />
        <span className="text-2xl font-bold text-[#c62b6d]">VISIT OUR WEBSITE</span>
      </div>
    </div>
  </div>
      <div className="flex justify-center mt-4 mb-20">
        <a
          href="/contact-us"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block"
        >
          <button
            className="px-6 py-3 text-black font-medium text-3xl
    bg-gradient-to-b from-[#c56ea3] to-[#fb776e]
    border-4 border-[#ffa6c7]
    rounded-xl
    hover:shadow-[2px_2px_0px_#b14773]
    active:shadow-[1px_1px_0px_#b14773]
    transition-all duration-150"
            style={{ fontFamily: "Trebuchet MS, sans-serif" }}
          >
            Talk to Our Experts
          </button>
        </a>
      </div>
      {isModalOpen && (
        <div className="fixed z-50 inset-0 md:p-0 p-10  bg-black bg-opacity-50 flex items-center justify-center">
          <div className="relative bg-[#F1F6FF]   p-8 lg:px-10 rounded-lg max-h-screen   max-w-md w-full">
            <button
              className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
              onClick={closeModal}
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                ></path>
              </svg>
            </button>

            <form onSubmit={handleSubmitcontact}>
              <div className="max-h-[400px] overflow-y-auto custom-scrollbar pr-4 ">
                <div className="mb-4">
                  <label className=" text-gray-700">First Name</label>
                  <input
                    type="text"
                    id="firstname"
                    name="firstname"
                    value={firstname}
                    onChange={(e) => setfirstname(e.target.value)}
                    className="w-full px-3 py-2 border rounded"
                    required
                  />
                  {errors.firstname && (
                    <p className="text-red-500 text-sm">{errors.firstname}</p>
                  )}
                </div>
                <div className="mb-4">
                  <label className=" text-gray-700">Last Name</label>
                  <input
                    type="text"
                    name="lastname"
                    id="lastname5"
                    value={lastname}
                    onChange={(e) => setlastname(e.target.value)}
                    className="w-full px-3 py-2 border rounded"
                    required
                  />
                  {errors.lastname && (
                    <p className="text-red-500 text-sm">{errors.lastname}</p>
                  )}
                </div>

                <div className="mb-4 w-full">
                  <label
                    htmlFor="phoneNumber"
                    className="block text-gray-700 text-sm mb-2"
                  >
                    Phone Number
                  </label>
                  <PhoneInput
                    country={"in"}
                    type="tel"
                    id="Phonenumber"
                    required
                    name="phonenumber"
                    value={phoneNumber}
                    onChange={(number, country) =>
                      handlePhoneNumberChange(number, country)
                    }
                    inputClass="custom-phone-input2"
                    buttonClass="border rounded"
                    dropdownClass="border rounded"
                    placeholder="Enter Phone Number"
                    enableSearch={true}
                    inputProps={{
                      required: true,
                      autoFocus: false,
                    }}
                  />
                  {errors.phoneNumber && (
                    <p className="text-red-500 text-sm">{errors.phoneNumber}</p>
                  )}
                </div>
                <div className="mb-4">
                  <label className="text-gray-700">Company Name</label>
                  <input
                    type="text"
                    id="companyname"
                    name="companyName"
                    value={companyName}
                    onChange={(e) => setCompanyName(e.target.value)}
                    className="w-full px-3 py-2 border rounded"
                    required
                  />
                  {errors.companyName && (
                    <p className="text-red-500 text-sm">{errors.companyName}</p>
                  )}
                </div>
                <div className="mb-4">
                  <label className=" text-gray-700">Business Email</label>
                  <input
                    type="email"
                    id="businessemail"
                    name="businessemail"
                    value={businessemail}
                    onChange={(e) => setEmailId(e.target.value)}
                    className="w-full px-3 py-2 border rounded"
                    required
                  />
                  {errors.businessemail && (
                    <p className="text-red-500 text-sm">
                      {errors.businessemail}
                    </p>
                  )}
                </div>

                <div className="mb-4">
                  <label className=" text-gray-700">
                    Project Details (Optional)
                  </label>
                  <input
                    type="text"
                    id="projectdetails"
                    name="projectdetails"
                    value={projectdetails}
                    onChange={(e) => setprojectdetails(e.target.value)}
                    className="w-full px-3 py-2 border rounded"
                  />
                  {errors.companyName && (
                    <p className="text-red-500 text-sm">{errors.companyName}</p>
                  )}
                </div>
                <div className="disclaimerContainercontact">
                  <label className="checkboxLabel">
                    <input
                      type="checkbox"
                      checked={isChecked}
                      onChange={handleCheckboxChange}
                      className="checkbox"
                    />
                    <span className="checkboxText">
                      I agree and authorize team to contact me and/or send
                      relevant information over Email, SMS & WhatsApp. This will
                      override the registry with DNC/NDNC.
                    </span>
                  </label>
                </div>
                {errors.terms && (
                  <p className="text-red-500 text-sm">{errors.terms}</p>
                )}
                <div className="linksContainer">
                  <a href="/terms-of-service/" className="link">
                    Terms of Service
                  </a>
                  <a href="/privacy-policy/" className="link">
                    Privacy Policy
                  </a>
                </div>
              </div>
              <div className="mb-4">
                <button
                  id="submit"
                  type="submit"
                  className={`w-full px-4 py-2 bg-[#C62B6D] text-white rounded ${
                    !isChecked || isLoading
                      ? "opacity-50 cursor-not-allowed"
                      : ""
                  }`}
                  disabled={!isChecked || isLoading}
                >
                  {isLoading ? (
                    <div className="flex items-center justify-center space-x-2">
                      <svg
                        className="animate-spin h-5 w-5 text-white"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <circle
                          className="opacity-25"
                          cx="12"
                          cy="12"
                          r="10"
                          stroke="currentColor"
                          strokeWidth="4"
                        />
                        <path
                          className="opacity-75"
                          fill="currentColor"
                          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                        />
                      </svg>
                      <span>Submitting...</span>
                    </div>
                  ) : (
                    "Submit"
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
      {isSuccessOpen && (
        <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center">
          <div className="relative bg-white p-8 rounded-lg max-w-md w-full text-center">
            <button
              className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
              onClick={closeSuccessModal}
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                ></path>
              </svg>
            </button>
            <h2 className="text-2xl font-bold mb-4">Success!</h2>
            <p className="mb-4">Your request has been sent successfully.</p>
            <button
              id="close"
              className="px-4 py-2 bg-[#C62B6D] text-white rounded"
              onClick={closeSuccessModal}
            >
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Visualai;
